import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './Home.module.scss';
import images from '~/assets/images';
import PostFeatered from './PostFeatered/PostFeatered';
import Event from './Event/Event';
import Lesson from './Lesson/Lesson';
import CourseData from './CourseData/CourseData';
import SocialMemory from './SocialMemory/SocialMemory';
import { useNavigate } from 'react-router-dom';
import { home } from '~/Store/Action/homeActions';
import { socialMemory } from '~/Store/Action/bookActions';
import { Link, NavLink } from 'react-router-dom';

// Import Swiper styles
import 'swiper/css';
import Section from '~/components/Section/Section';

const cx = classNames.bind(styles);

function Home() {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const handleRedirect = () => {
        navigate('/su-kien');
    };
    const list = useSelector((state) => state.home.list);
    const listSocialMemory = useSelector((state) => state.book.listSocialMemory);
    // console.log(list);
    useEffect(() => {
        dispatch(home()); // Dispatch action để lấy dữ liệu khi component được mount
        dispatch(socialMemory());
    }, []);
    return (
        <Box className={cx('wrapper')}>
            <PostFeatered featers={list} />
            <Event events={list} />
            <Box className={cx('course')}>
                {list?.data?.banners && (
                    <Link
                        className={cx('item-sub-menu')}
                        target="_blank"
                        to={list?.data?.banners ? list?.data?.banners[1].link : '#'}
                    >
                        <img
                            className={cx('image-banner', 'img-fluid')}
                            src={list?.data?.banners ? list?.data?.banners[1].image : images.Banner}
                            alt="Viện Đại học SocialLife"
                            title="Viện Đại học SocialLife"
                        />
                    </Link>
                )}
                <Lesson courses={list} />
                <CourseData book_categories={list} />
                <Section
                    className={cx('SocialMemory')}
                    // buttonTitle="Xem thêm"
                    // sectionTitle="Sự kiện nổi bật"
                    onClickButton={handleRedirect}
                >
                    {list?.data?.banners && (
                        <Link
                            className={cx('item-sub-menu')}
                            target="_blank"
                            to={list?.data?.banners ? list?.data?.banners[1].link : '#'}
                        >
                            <img
                                className={cx('image-banner', 'img-fluid')}
                                src={list?.data?.banners ? list?.data?.banners[2].image : images.Banner}
                                alt="Viện Đại học SocialLife"
                                title="Viện Đại học SocialLife"
                            />
                        </Link>
                    )}
                </Section>
                <SocialMemory book_categories={listSocialMemory} />
            </Box>
        </Box>
    );
}

export default Home;
